<!-- 服务管理-服务团队-页面级 -->
<template>
  <div class='team'>
    <service-team-detail />
  </div>
</template>

<script>
import serviceTeamDetail from './components/service-team-detail'
export default {
  name: 'appointmnet-team',
  components: {
    serviceTeamDetail
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
